import React from 'react'

import PropTypes from 'prop-types'

import { Container, Error } from './styles'
import { FiAlertOctagon } from 'react-icons/fi'
import { useField } from '@unform/core'
import { Column, Row } from '@shared/components/Layout'
import Input from '@shared/components/Form/Input'

const Checkbox = ({ label, name, input, horizontal, options, onChange, defaultCheckedField, emitFirstOption }) => {
  const inputRefs = React.useRef([])
  const { fieldName, registerField, defaultValue, error } = useField(name)

  // const [inputsData, setInputsData] = React.useState([])

  const defaultChecked = React.useMemo(() => {
    if (Array.isArray(defaultValue)) {
      return defaultValue.map((option) => String(option[defaultCheckedField]))
    } else if (typeof defaultValue === 'object') {
      const value = defaultValue[defaultCheckedField]
      return value ? [String(value)] : []
    } else {
      return [String(defaultValue)]
    }
  }, [defaultValue, defaultCheckedField])

  React.useEffect(() => {
    registerField({
      name: fieldName,
      path: 'value',
      ref: inputRefs.current,
      getValue (refs) {
        const checkedValues = refs
          .filter((box) => box.checked)
          .map((box) => String(box.value))

        const checkedOptions = options.filter((option) =>
          checkedValues.includes(String(option.id))
        )

        return emitFirstOption ? checkedOptions.find(Boolean) : checkedOptions
      },

      setValue (refs, values) {
        if (!Array.isArray(values)) return

        const checkedValues = values.map((option) => String(option.id))

        refs
          .filter((box) => checkedValues.includes(String(box.value)))
          .forEach((box) => (box.checked = true))
      }
    })
  }, [options, fieldName, registerField, emitFirstOption])

  return (
    <Container horizontal={horizontal} onChange={onChange}>
      {label && <div className="radio__name">{label}</div>}

      {options.map((option, index) => (
        <Row $justifyBetween $itemsCenter key={option.id}>
          <Column xs={horizontal ? 6 : 'auto'}>
            <label className="radio__item">
              <input
                key={defaultChecked.includes(String(option.id))}
                className="radio__input"
                ref={(boxRef) => (inputRefs.current[index] = boxRef)}
                type="checkbox"
                name={fieldName}
                value={option.id}
                defaultChecked={defaultChecked.includes(String(option.id))}
              />
              <span className="radio__label">{option.label || option.name}</span>
            </label>
          </Column>
          {input && (
            <Column xs={horizontal ? 6 : 'auto'}>
              <Input
                name={`${name}_${input.group}.${index}.parent_id`}
                value={option.id}
                containerStyle={{ display: 'none' }}
                readOnly
              />
              <Input
                {...input}
                label={input.label}
                name={`${name}_${input.group}.${index}.${input.name || 'value'}`}
                onFocus={() => { inputRefs.current[index].checked = true }}
                onBlur={(event) => { inputRefs.current[index].checked = !!event.target.value }}
              />
            </Column>
          )}
        </Row>
      ))}

      {error && (
        <Error title={error}>
          <FiAlertOctagon color="#c53030" size={20} />
        </Error>
      )}
    </Container>
  )
}

Checkbox.defaultProps = {
  defaultCheckedField: 'id',
  horizontal: false
}

Checkbox.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  withTaxs: PropTypes.bool,
  emitFirstOption: PropTypes.bool,
  defaultCheckedField: PropTypes.string,
  horizontal: PropTypes.bool,
  onChange: PropTypes.func,
  input: PropTypes.shape({
    label: PropTypes.string,
    name: PropTypes.string,
    group: PropTypes.string.isRequired
  }),
  options: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.any,
      label: PropTypes.string
    })
  ).isRequired
}

export default Checkbox
